import React, { Component } from "react";
import { connect } from "react-redux";
import moment from "moment";
import styled from "styled-components";
import ActionCreator from "../ActionCreator";
import * as Widget from "./Widget2";

class HecafeBlogListItem extends Component {
  render() {
    let { content, navActions } = this.props;
    return (
      <Wrapper onClick={() => navActions.push(`/blog/${content.path}`)}>
        <Widget.Row
          align="center"
          css={`
            width: 100%;
            padding: 24.5px 0px;
            @media screen and (max-width: 500px) {
              flex-direction: column;
            }
          `}
        >
          <FeatureImage
            src={content.thumbnail}
            css={`
              margin-right: 50px;
              @media screen and (max-width: 1000px) {
                margin-right: 40px;
              }
              @media screen and (max-width: 750px) {
                margin-right: 30px;
              }
              @media screen and (max-width: 500px) {
                margin-right: 0px;
                margin-bottom: 15px;
              }
            `}
          />
          <Widget.Container css="flex: 1; margin-top: 15px;">
            <Title
              css={`
                margin-bottom: 30px;
                @media screen and (max-width: 500px) {
                  margin-bottom: 20px;
                  text-align: center;
                }
              `}
            >
              {content.title}
            </Title>
            <Text>
              {content.description &&
                (content.description.length <= 188
                  ? content.description.slice(0, 189)
                  : content.description.slice(0, 186) + "...")}
            </Text>
            <Widget.Row
              align="center"
              justify="space-between"
              css="margin-top: 60px; width: 100%;"
              wrap={"true"}
            >
              <Text css="color: #B4B9C4;">
                {moment(content.date).format("MMMM DD, YYYY")}/@好咖嚴選
              </Text>
              <Widget.SeeMoreButton label="閱讀更多" onClick={() => 0} />
            </Widget.Row>
          </Widget.Container>
        </Widget.Row>
        <Widget.SectionLine css="width: 100%;" />
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
  width: 100%;
  cursor: pointer;
`;

const FeatureImage = styled.div`
  background-image: url(${props => props.src});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;

  width: 305px;
  height: 250px;
  border-radius: 10px;

  @media screen and (max-width: 768px) {
    width: 244px;
    height: 200px;
  }

  ${props => props.css || ""};
`;

const Title = styled.div`
  line-height: 24px;
  letter-spacing: 0.63px;
  font-size: 22px;
  color: #4e4e4e;

  @media screen and (max-width: 500px) {
    font-size: 14px;
  }

  ${props => props.css || ""};
`;

const Text = styled.div`
  line-height: 20px;
  letter-spacing: 0.4px;
  font-size: 14px;
  color: #4e4e4e;

  @media screen and (max-width: 500px) {
    font-size: 12px;
  }

  ${props => props.css || ""};
`;

export default connect(
  null,
  ActionCreator
)(HecafeBlogListItem);
